const leaf = () => ({ left: 'close', op: '>', right: 0 });

export default function ConditionTree({ node, onChange, operands, depth = 0 }) {
  const kind = node.all ? 'all' : node.any ? 'any' : node.not ? 'not' : 'condition';
  const children = kind === 'not' ? [node.not] : node[kind];
  return <fieldset style={{ margin: '8px 0', padding: 8, minWidth: 0 }}>
    <legend>Condition {depth + 1}</legend>
    <select aria-label="Condition group" value={kind} onChange={(e) => {
      const value = e.target.value;
      onChange(value === 'condition' ? leaf() : value === 'not' ? { not: leaf() } : { [value]: [leaf()] });
    }}>
      <option value="condition">Compare</option>
      {depth < 5 && <><option value="all">ALL (AND)</option><option value="any">ANY (OR)</option><option value="not">NOT</option></>}
    </select>
    {kind === 'condition' ? <div className="aq-rule-row">
      <Operand value={node.left} onChange={(left) => onChange({ ...node, left })} operands={operands} label="Left operand" />
      <select aria-label="Operator" value={node.op} onChange={(e) => onChange({ ...node, op: e.target.value })}>
        {['>', '<', '>=', '<=', '==', '!=', 'cross_above', 'cross_below'].map((op) => <option key={op}>{op}</option>)}
      </select>
      <Operand value={node.right} onChange={(right) => onChange({ ...node, right })} operands={operands} label="Right operand" />
    </div> : <>
      {children.map((child, i) => <div key={i}>
        <ConditionTree node={child} operands={operands} depth={depth + 1} onChange={(next) => onChange(kind === 'not' ? { not: next } : { [kind]: children.map((c, j) => i === j ? next : c) })} />
        {kind !== 'not' && children.length > 1 && <button type="button" onClick={() => onChange({ [kind]: children.filter((_, j) => i !== j) })}>Remove condition</button>}
      </div>)}
      {kind !== 'not' && children.length < 20 && <button type="button" onClick={() => onChange({ [kind]: [...children, leaf()] })}>Add condition</button>}
    </>}
  </fieldset>;
}

function Operand({ value, onChange, operands, label }) {
  const numeric = typeof value === 'number';
  const key = numeric ? 'constant' : JSON.stringify(value);
  const missing = !numeric && !operands.some((o) => JSON.stringify(o.ref) === key);
  return <span>
    <select aria-label={label} value={key} onChange={(e) => onChange(e.target.value === 'constant' ? 0 : JSON.parse(e.target.value))}>
      <option value="constant">Number</option>
      {missing && <option value={key}>Saved operand: {key}</option>}
      {operands.map((o) => <option key={JSON.stringify(o.ref)} value={JSON.stringify(o.ref)}>{o.label}</option>)}
    </select>
    {numeric && <input aria-label={`${label} number`} type="number" step="any" value={value} onChange={(e) => onChange(Number(e.target.value))} style={{ width: 90 }} />}
  </span>;
}
